import "$styles/index.css"
import "$styles/syntax-highlighting.css"

import components from "$components/**/*.{js,jsx,js.rb,css}"

requestAnimationFrame(() => document.body.classList.add("ready"))

const dock = document.getElementById("dock")
const hero = document.getElementById("top")
if (dock && hero) {
  let trigger = 0
  const measure = () => { trigger = hero.offsetHeight - 90 }
  const onScroll = () => dock.classList.toggle("show", window.scrollY > trigger)

  requestAnimationFrame(() => { measure(); onScroll() })
  window.addEventListener("scroll", onScroll, { passive: true })
  window.addEventListener("resize", measure, { passive: true })
}
